import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import DeletePostContentModal from './DeletePostContentModal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function PostContentShowAll() {
  const [postList, setPostList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [postToDelete, setPostToDelete] = useState(null);
  
    const callApiPostContent = async () => {
    try {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      };
      const url = process.env.REACT_APP_API_URL + 'postcontent/showAll';
      const response = await axios.get(url, {headers});
      setPostList(response.data);
      setFilteredList(response.data);
    }
    catch (error) {
      console.log(error);
    } finally {
      setLoading(false); 
    }
  };
   useEffect(() => {
     callApiPostContent();
   }, [])

   useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredList(postList);
    } else {
      const filtered = postList.filter((item) =>
        (item.postcontentname || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item.postcontenttitle || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item.postcontentid || '').toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredList(filtered);
    }
  }, [searchTerm, postList]);

   const handleOpenDeleteModal = (post) => {
    setPostToDelete(post);
    setShowDeleteModal(true);
  };
  const handleDeletePost = async (postToDeleteSrno) => {
    try {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      };
      const url = process.env.REACT_APP_API_URL + `postcontent/delete/${postToDeleteSrno}`;
      await axios.delete(url, {headers});
      setShowDeleteModal(false);
      const updatedPostList = postList.filter((item) => item.srno !== postToDeleteSrno);
      setPostList(updatedPostList);
      toast.success("Post content deleted successfully", {
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
    } catch (error) {
      console.error(error);
      setShowDeleteModal(false);
      toast.error("Failed to delete post content", {
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
    }
  };

  return (
    <div>
       <ToastContainer />

      <div className="main-card">
        <div className="toolbar-container">
          <h2 className="page-title">Post Content List</h2>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span className="results-count">
              {filteredList.filter(item => item.isactive === 1).length} results
            </span>
            <input
              type="text"
              className="search-box"
              placeholder="Search by Name / Title / ID"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Link to="/createpost" className="btn-add-primary">
              + Create New Post
            </Link>
          </div>
        </div>

        <div className="table-header-panel">
          Post Content List
        </div>

        <div className="table-responsive">
          <table className="custom-table" style={{ tableLayout: 'fixed', width: '100%', fontSize: '0.85rem' }}>
            <thead>
              <tr>
                <th style={{ width: '50px' }}>Sr No</th>
                <th style={{ width: '80px' }}>Content Id</th>
                <th style={{ width: '120px' }}>Name</th>
                <th style={{ width: '120px' }}>Title</th>
                <th style={{ width: '200px' }}>Post Content</th> 
                <th style={{ width: '80px' }}>Type</th>
                <th style={{ width: '60px' }}>Post Id</th>
                <th style={{ width: '60px' }}>Loc Id</th>
                {/* ADDED ACTIVE COLUMN HEADER */}
                <th style={{ width: '80px' }}>is Active</th>
                <th style={{ width: '140px' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10" className="text-center">Loading...</td>
                </tr>
              ) : filteredList.filter(item => item.isactive === 1).length === 0 ? (
                <tr>
                  <td colSpan="10" className="text-center">No post content found</td>
                </tr>
              ) : (
                filteredList
                  .filter(item => item.isactive === 1)
                  .map((item, index) => (
                    <tr key={index}>
                      <td>{item.srno}</td>
                      <td>{item.postcontentid}</td>
                      <td style={{ fontWeight: '600' }}>{item.postcontentname}</td>
                      <td>{item.postcontenttitle}</td>
                      <td>
                        <div 
                          style={{ 
                            maxHeight: '40px', 
                            overflow: 'hidden', 
                            textOverflow: 'ellipsis', 
                            whiteSpace: 'nowrap' 
                          }}
                          dangerouslySetInnerHTML={{ __html: item.postcontent }} 
                        />
                      </td>
                      <td>{item.postcontenttype}</td>
                      <td>{item.postid}</td>
                      <td>{item.postlocationid}</td>
                      {/* ADDED ACTIVE COLUMN DATA CELL */}
                      <td>
                        <span className={`badge ${item.isactive === 1 ? 'bg-success' : 'bg-danger'}`}>
                          {item.isactive === 1 ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td>
                        <div className="action-btn-container">
                          <Link to={`/postupdate/${item.srno}`} className="btn-action-edit">Edit</Link>
                          <button
                            className="btn-action-delete"
                            onClick={() => handleOpenDeleteModal(item)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <DeletePostContentModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={() => handleDeletePost(postToDelete.srno)}
        postToDelete={postToDelete}
      />
      
    </div>
  );
}

export default PostContentShowAll;
